<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="none" viewBox="0 0 17 17">
  <path fill="#A7A4A4" d="m16.42 15.55-3.847-3.846a6.77 6.77 0 1 0-.869.87l3.847 3.847a.614.614 0 1 0 .87-.87ZM1.847 7.38a5.533 5.533 0 1 1 5.532 5.532A5.539 5.539 0 0 1 1.847 7.38Z"/>
</svg>
